export default "__VITE_ASSET__DZgdzHif__"